// eslint-disable-next-line no-unused-vars
import store from "@/store";
import { defaultUpload } from "@/mobile-device-bridge/MobileDeviceBridgeFileUploadHelper";
import i18n from "@/language/i18n";

/**
 * @param {String} type             type of the window. (contained in windowIdentifier - WindowFormModule)
 * @param {String|Number}           id id of the window. (contained in windowIdentifier - WindowFormModule)
 * @param {String} targetFieldPath  path where file gets stored.
 * @param {Function} customCallback Will override all previous settings.
 * @param {String} taskPayload      additional stored information.
 * @param {String} singleMode       allows single or multiple upload.
 * @param {Object} mobileDeviceBridge MobileDeviceBridge
 * @constructor
 */
var MobileDeviceBridgeTakePhotoHandler = function ({ type, id, targetFieldPath, customCallback, taskPayload, singleMode }) {
    const isNotAllRequiredFieldsPassed = !(type && id && targetFieldPath);
    const isNoCustomCallbackPassed = !customCallback;

    if (isNotAllRequiredFieldsPassed && isNoCustomCallbackPassed) {
        throw 'Required parameters missing. Use config.type, ' +
        'config.id and config.targetFieldPath together or ' +
        'only config.customCallback';
    }

    /**
     * @returns {Promise<{value: String, command: String}>}
     */
    this.invokeNotification = async function () {
        let taskId = await store.dispatch('mobileWrapperTasks/setTask', { callback: _getCallback(), taskPayload: _getTaskPayload() });
        let command = singleMode ? "TAKE_ONE_PHOTO" : "TAKE_PHOTO";
        return { command , value: taskId, instance: window.location.href };
    }

    /**
     * @returns {Function}
     * @private
     */
    var _getCallback = function () {
        if (customCallback) { return customCallback }
        return _callback;
    }

    /**
     * @returns {Function}
     * @private
     */
     var _getTaskPayload = function () {
        if (taskPayload) { return taskPayload }
        return {};
    }

    var _callback = async function (base64Strings, taskPayload) {
        defaultUpload( 
            type, 
            id, 
            targetFieldPath, 
            base64Strings, 
            taskPayload,
            {
                success: i18n.t('MobileDeviceBridge.sentences.addedPicture'),
                error: (errorNum) => i18n.t('MobileDeviceBridge.sentences.couldNotAddPicture', errorNum > 1 ? [errorNum] : [i18n.t('Common.the')])
            } 

        );
    }

}

export default MobileDeviceBridgeTakePhotoHandler;

